// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2W1fv","large":"styles_large__lftcH"};